import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { updateCacheByType } from "../../../graphql/GraphQlProvider";
import { StatusMessage } from "../../../graphql/common.datatypes";

export interface AddNoteVars {
    data: {
        user_id: number;
        level: number;
        type: number;
        type_id: number;
        code: string;
        description: string;
    };
}

interface AddNoteData {
    addNote: StatusMessage;
}

export const ADD_NOTE_MUTATION = gql`
    mutation addLog($data: AddLogInput!) {
        addLog(data: $data) {
            status
            message
        }
    }
`;

export const addNote = () =>
    useMutation<AddNoteData, AddNoteVars>(ADD_NOTE_MUTATION, {
        update: updateCacheByType("WcvLog")
    });

export default addNote;
